module.exports = __webpack_public_path__ + "img/no_prize.fe849363.png";